export enum AssignmentFilterTypes {
  Company = 'company',
  Customer = 'customer',
  Worker = 'worker',
  WorkerType = 'workerType',
  TerminationReason = 'termination',
  Status = 'status',
  Date = 'date',
}
